import { FC } from 'react'
import { SvgProps } from './svgProps'

const FilledHeartIconListingRedesign: FC<SvgProps> = ({
  width,
  height,
  color = 'white'
}) => (
  <svg
    width={width || 22}
    height={height || 20}
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9999 2.82521L10.3099 2.12179C8.04702 -0.180049 4.53269 -0.0118716 2.4598 2.50055C0.386909 5.01152 0.539768 8.91323 2.80266 11.2165L10.8985 19.4572C10.9556 19.5143 11.0456 19.5143 11.1014 19.4572L19.1986 11.2151C21.4601 8.91323 21.6129 5.01152 19.5401 2.49909C17.4672 -0.00894678 13.9528 -0.178586 11.6899 2.12325L10.9999 2.82375V2.82521Z"
      fill={color}
      stroke="#222222"
      strokeLinecap="round"
    />
  </svg>
)

export default FilledHeartIconListingRedesign
